import React, { useState } from "react";
import Button from "../../components/button/button";
import { Formik, Form, Field, FormikHelpers } from "formik";
import * as Yup from "yup";
import { triggerEmail } from "../../firebase/email";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Section from "../../components/section";
import background from "../../assets/backgrounds/landing-6.svg";

const ContactUs: React.FC = () => {
  return (
    <Section backgroundImage={background} id="contact-us">
      <div className="flex flex-col items-center justify-center">
        <div className="container mx-auto px-4 w-3/4">
          <h2 className="text-4xl sm:text-5xl font-bold mb-8 text-center text-white">
            Have A Question?
          </h2>
          <div className="w-full">
            <ContactUsForm />
          </div>
        </div>
        <ToastContainer />
      </div>
    </Section>
  );
};

interface FormValues {
  name: string;
  email: string;
  content: string;
}

const initialValues: FormValues = { name: "", email: "", content: "" };

const validationSchema = Yup.object({
  name: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email address").required("Required"),
  content: Yup.string().required("Required"),
});

const ContactUsForm: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (
    values: FormValues,
    { resetForm }: FormikHelpers<FormValues>
  ) => {
    setLoading(true);
    try {
      await triggerEmail(values.email, values.name, values.content);
      resetForm();
      toast.success("Email sent successfully!");
    } catch (error) {
      toast.error("Failed to send email. Please try again.");
    }
    setLoading(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="rounded-lg px-4 py-6 md:px-8 md:py-8 w-full">
          <div className="mb-4">
            <Field
              name="name"
              placeholder="Name"
              className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
            />
          </div>
          <div className="mb-4">
            <Field
              name="email"
              placeholder="Email"
              type="email"
              className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
            />
          </div>
          <div className="mb-4">
            <Field
              name="content"
              placeholder="Content"
              as="textarea"
              rows={6}
              className="w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
            />
          </div>
          <div className="flex justify-center">
            <Button
              theme="primary"
              type="submit"
              disabled={loading}
              // className={`${
              //   loading
              //     ? "bg-gray-400 cursor-not-allowed"
              //     : "bg-blue-600 hover:bg-blue-700"
              // }`}
            >
              {loading ? "Submitting..." : "Submit"}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ContactUs;
